import { useContext } from 'react';
import { CalculatorAdvancedMode, CalculatorHTMMode } from '../../../../shared/classes/CalculatorMode';
import { CalculatorAdvancedModeContext, CalculatorHtmModeContext } from '../../../../shared/contexts/CalculatorContext';
import { SharedOutputEditComponent } from '../../components/SharedInputEdit';

export function BreakFixOutput(): JSX.Element {
    const [calculatorHTMModeValue,] = useContext(CalculatorHtmModeContext)!;
    const [calculatorAdvancedModeValue,] = useContext(CalculatorAdvancedModeContext)!;

    return (
        <div>

            <h2 className='acc-o-badge'>Break and Fix</h2>

            <div className="examinations">

                <SharedOutputEditComponent inputName="break_fix_exams_loss"/>
                <SharedOutputEditComponent inputName="break_fix_examinations_transfert_lost"/>
                <SharedOutputEditComponent inputName="break_fix_examinations_transfert_cost_loss"/>

            </div>

            <div className="operations">

                <SharedOutputEditComponent inputName="break_fix_operating_hours_lost"/>
                <SharedOutputEditComponent inputName="break_fix_surgery_dpt_cost_loss"/>
                <SharedOutputEditComponent inputName="break_fix_intensive_care_dpt_cost_loss"/>

            </div>

            <div className="workforce">

                <SharedOutputEditComponent inputName="break_fix_staff_cost_due_to_iddle_time"/>
                <SharedOutputEditComponent inputName="break_fix_staff_overtime_cost"/>
                <SharedOutputEditComponent inputName="break_fix_average_admin_fee_costs_for_rescheduling_exams"/>

            </div>

            <div className="revenue">

                <SharedOutputEditComponent inputName="break_fix_revenue_loss"/>

            </div>

            {
                calculatorHTMModeValue === CalculatorHTMMode.HTM
                    ? <div className="inhouse">

                        <SharedOutputEditComponent inputName="break_fix_labor_productivity_in_hours"/>
                        <SharedOutputEditComponent inputName="break_fix_labor_productivity"/>

                    </div>
                    : ''
            }

            <SharedOutputEditComponent inputName="break_fix_estimated_Loss"/>

            {
                calculatorAdvancedModeValue === CalculatorAdvancedMode.Advanced
                    ? <>
                        <SharedOutputEditComponent inputName="break_fix_patient_transfer_surgery_dpt_loss"/>
                        <SharedOutputEditComponent inputName="break_fix_total_hospital_estimated_loss"/>
                    </>
                    : ''
            }

        </div>
    );
}
